import { useEffect, useState } from "react";
import axios from "axios";

 
const useGestiondeReciclajeNfu = (year, mes, token, idAdministrador) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(
          `https://seguimientoconductor-nodejs-pits.com/administrador_seginus/obtenerGestiondeReciclajeNfu`,
          { anio: year, mes: mes, id_administrador: idAdministrador},
          {headers: { Authorization: token }}
        );
        setData(response.data); 
      } catch (error) {
         
      }
    };
    if (token && idAdministrador) {
      fetchData(); 
    }
  }, [year, mes, token, idAdministrador]);

  return data;
};

 
export default useGestiondeReciclajeNfu;